export const MONITOR_JOB = 'MONITOR_JOB'
export const UPDATE_JOB_STATUS = 'UPDATE_JOB_STATUS'
export const REMOVE_JOB_FROM_MONITOR = 'REMOVE_JOB_FROM_MONITOR'
export const CLOSE_JOB_MONITOR = 'CLOSE_JOB_MONITOR'
